<template>
  <div>
    <Loading
    :active.sync="isLoading"
    :can-cancel="true"
    :on-cancel="onCancel"
    :is-full-page="fullPage"
  ></Loading>
    <div class="flow" v-if="activateFlow">
      <div class="flow--overlay" @click="activateFlow = false">
          {{pageStep}}
      </div>
      <div class="flow--box">
          <div class="flow--content" v-if="pageStep == 0">
            <div class="flow--title">Create Your New Contest</div>
            <p class="flow--p">Your page name will identify your page inside the DemoBottle interface.</p>
            <br/>
            <div class="flow--label">What is the name of your page?</div>
            <input
              type="text"
              placeholder="Page name"
              name="Name"
              v-model="pageNew.name"
              class="input--text email login--input-bottom"
            />
            <hr />
            <div class="flow--buttons">
              <div class="flow--button flow--button_center" v-if="pageNew.name != ''" @click="pageStep++">
                <div class="flow--button-contents" > ›</div>
              </div>
            </div>

          </div>
          <div class="flow--content" v-if="pageStep == 1">
            <div class="flow--title">Page Information</div>
            <p class="flow--p">This information will be shown on your page.</p>
            <br/>
            <div class="flow--label">Title </div> 
            <input
              type="text"
              placeholder="Page name"
              name="Name"
              v-model="pageNew.title"
              class="input--text email login--input-bottom"
            />
            <div class="flow--label">Description</div>
            <textarea type="text" v-model="pageNew.description" placeholder="Description" name="title" class="input--text email login--input-bottom input--textarea"></textarea>
            <hr />
            <div class="flow--buttons">
              <div class=" flow--button_left" @click="pageStep--">
                <div class="flow--button-contents"> ‹ Back</div>
              </div>
              <div class="flow--button flow--button_right" v-if="pageNew.title != ''" @click="pageStep++">
                <div class="flow--button-contents" > ›</div>
              </div>
            </div>
            
          </div>
          <div class="flow--content" v-if="pageStep == 2">
            <div class="flow--title">Claim Your Unique URL</div>
            <p class="flow--p">
              This will be your shareable url. Make sure you choose a descriptive name.
              Don't use whitespaces.
            </p>
            <br/>
            <div class="flow--field-inline">
              
              <div class="flow--label-inline">https://remixinbox.com/</div>
              <input
                type="text"
                placeholder="URL"
                name="URL"
                @change="checkAvailablity(pageNew.customUrl)"
                v-model="pageNew.customUrl"
                v-bind:class="{ field_valid: available, field_invalid: !available }"
                class="input--text flow--inline-field email login--input-bottom"
              />
            </div>
            
            <hr />
            <div class="flow--buttons">
              <div class=" flow--button_left" @click="pageStep--">
                <div class="flow--button-contents"> ‹ Back</div>
              </div>
              <div class="flow--button flow--button_right" v-if="available" @click="pageStep++">
                <div class="flow--button-contents" > ›</div>
              </div>
            </div>
          </div>
          <div class="flow--content" v-if="pageStep == 3">
            <div class="flow--title">Branding</div>
            <p class="flow--p">Add your own brand colors to your DemoBottle page.</p>
            <br/>
            <div class="page-editor--label">Primary Color</div>
            <picker v-model="pageNew.primaryColor"></picker>
            <div class="page-editor--label">
              Secondary Color
            </div>
            <picker v-model="pageNew.secondaryColor"></picker>
            
            <div class="page-editor--label">
              Text Color
            </div>
            <picker v-model="pageNew.textColor"></picker>
            <hr />
            <div class="flow--buttons">
              <div class=" flow--button_left" @click="pageStep--">
                <div class="flow--button-contents"> ‹ Back</div>
              </div>
              <div class="flow--button flow--button_right" v-if="available" @click="pageStep++">
                <div class="flow--button-contents" > ›</div>
              </div>
            </div>
          </div>
          <div class="flow--content" v-if="pageStep == 4">
           <div class="flow--title" @click="createPage()">Track Details</div>
           <p class="flow--p">Provide your participants with some details about the original track.</p>
           <br/>
            <div class="page-editor--label">Track name</div>
             <input
             type="text"
             placeholder="Track name"
             name="Name"
             v-model="pageNew.trackName"
             class="input--text  login--input-bottom"
             />
             <br>
             <div class="page-editor--label">Artist name</div>
             <input
             type="text"
             placeholder="Artist name"
             name="Name"
             v-model="pageNew.trackArtist"
             class="input--text  login--input-bottom"
             />
             <div class="page-editor--label">Track URL</div>
             <input
             type="text"
             placeholder="URL of the original track"
             name="Name"
             v-model="pageNew.trackUrl"
             class="input--text  login--input-bottom"
             />
             <hr />
             <div class="page-editor--label">Stems URL</div>
             <input
             type="text"
             placeholder="URL of the original track"
             name="Name"
             v-model="pageNew.trackStems"
             class="input--text  login--input-bottom"
             />
            <div class="flow--buttons">
              <div class=" flow--button_left" @click="pageStep--">
                <div class="flow--button-contents"> ‹ Back</div>
              </div>
              <div class="flow--button flow--button_right" v-if="available" @click="pageStep++">
                <div class="flow--button-contents" > ›</div>
              </div>
            </div>
          </div>
          <div class="flow--content" v-if="pageStep == 5">
            <div class="flow--title" @click="createPage()">Contest Details</div>
            <p class="flow--p">When does your contest start and close?</p>
            <br/>
             <div class="page-editor--label">Start date</div>
              <Datepicker v-model="pageNew.startDate"></Datepicker>
              <br>
              <div class="page-editor--label">Closing date</div>
              <Datepicker v-model="pageNew.endDate"></Datepicker>

              <div class="flow--buttons">
                <div class=" flow--button_left" @click="pageStep--">
                  <div class="flow--button-contents"> ‹ Back</div>
                </div>
                <div class="flow--button flow--button_right" v-if="available" @click="pageStep++">
                  <div class="flow--button-contents" > ›</div>
                </div>
              </div>
          </div>
          <div class="flow--content" v-if="pageStep == 6">
            <div class="flow--title" @click="createPage()">Branding</div>
            <p class="flow--p">Add a logo and background.</p>
            <br/>
             <div class="page-editor--label">Logo</div>
              <div
                class="page-editor--logo"
                id="preview--logo"
                v-bind:style="{
                  'background-image':
                    'url(' + pageNew.logoUrl + ')',
                }"
              ></div>
             <input type="file"  @change="changeAssets($event, 'logo')" style="margin: 0; background-color: black; color: white; background-position: initial initial; background-repeat: initial initial;" accept="image/*" id="file-logo">
              <br>
              <div class="page-editor--label">Background</div>
              <div
                class="page-editor--background"
                id="preview--background"
                v-bind:style="{
                  'background-image':
                    'url(' + pageNew.backgroundUrl + ')',
                }"
              ></div>
              <input type="file" @change="changeAssets($event, 'background')" style="margin: 0; background-color: black; color: white; background-position: initial initial; background-repeat: initial initial;"  accept="image/*" id="file-background">

              <div class="flow--buttons">
                <div class=" flow--button_left" @click="pageStep--">
                  <div class="flow--button-contents"> ‹ Back</div>
                </div>
                <div class="page-new--button" style="background: white; color: black; margin-bottom:4em;" v-on:click="createPage()">Create</div>
              </div>
          </div>
          <div class="flow--progress">
            <div class="flow--progress-inner" v-bind:style="progress"></div>
          </div>
      </div>
    </div>
    <div class="content" :key="this.$globals.contests">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="page-new--button" v-on:click="newPage()">+ New Contest</div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-xs-12 col-sm-12 col-lg-4"
            v-for="page in this.$globals.contests"
            :key="page.id"
          >
            <div class="page-block">
              <div class="page-block--content">
                <div class="page-block--title">{{ page.name }}</div>
                <div class="page--link">
                  <div v-if="page.enabled" class="page--status-on"></div>
                  <div v-else class="page--status-off"></div>
                  <div class="page--url">
                    <a
                      :href="'https://remixinbox.com/' + page.customUrl"
                      target="_blank"
                    >
                      remixinbox.com/{{ page.customUrl
                      }}<svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        height="11px"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-external-link"
                      >
                        <path
                          d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                        ></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line></svg></a>
                        
                  </div>
                </div>
              </div>
              <hr />
              <div class="page-block--actions">
                <router-link
                  :to="{ name: 'contest-detail', params: { id: page.customUrl } }"
                  ><div class="page-block--button">Edit Contest</div></router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ColorPicker from "../components/ColorPicker";
import Datepicker from 'vuejs-datepicker';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "contests",
  components: {
    picker: ColorPicker,
    Datepicker,
    Loading
  },
  data() {
    return {
      pages: this.$globals.contests,
      activateFlow: false,
      
      isLoading: false,
      fullPage: true,
      
      pageStep: 0,
      progress: {
        width: (this.pageStep * 20 + 20) + "%",
      },
      pageNew: {
        title: "",
        name: "",
        organization_id: this.$globals.organization_id,
        description: "",
        customUrl: "",
        primaryColor: "#00000",
        secondaryColor: "#00000",
        textColor: "#FFFFF",
        enabled: 0,
        logoUrl: "https://app.demobottle.com/img/defaultlogo.png",
        backgroundUrl: "https://app.demobottle.com/img/defaultbackground.png"
      },
      available: false
    };
  },
  mounted() {},
  methods: {
    newPage: function() {
      this.activateFlow = true;
    },
    checkAvailablity: function() {
      var self = this;
      axios({
        method: "POST",
        crossdomain: true,
        headers: { "Content-Type": "Content-Type:application/json" },
        url: "/contest/check",
        data: {
          customUrl: self.pageNew.customUrl
        },
      })
      .then(function (response) {
        console.log(response.data);
        self.available = response.data.available;
        console.log(self.available)
      })
      .catch(function (error) {
        self.errors = error.response.data;
        self.isLoading = false;
      });
    },
    changeAssets(event, type){
      var file = event.target.files[0];
      var reader = new FileReader();
      if(type == "logo"){
        reader.onloadend = function () {
          document.getElementById("preview--logo").style.backgroundImage = 'url("' + reader.result + '")';
          document.getElementById("preview--form-logo").style.backgroundImage = 'url("' + reader.result + '")';
        }
        if (file) {
            reader.readAsDataURL(file);
        } else {
          console.log("no file");
        }
        
      }else{
        reader.onloadend = function () {
          document.getElementById("preview--background").style.backgroundImage = 'url("' + reader.result + '")';
          document.getElementById("preview--form-background").style.backgroundImage = 'url("' + reader.result + '")';
        }
        if (file) {
            reader.readAsDataURL(file);
        } else {
          console.log("no file");
          
        }
      }
      
    },
    timeConverter(UNIX_timestamp) {
      var a = new Date(UNIX_timestamp * 1000);
      return a;
    },
    createPage: function(){
        let self = this;
        this.isLoading = true;
        
        var formData = new FormData();
        var logo = document.querySelector('#file-logo');
        var background = document.querySelector('#file-background');
        
        formData.append("organization_id", this.$globals.organization_id);
        
        if (logo.files[0]){
          formData.append("logoImage",  logo.files[0]);
        }
        
        if (background.files[0]){
          formData.append("backgroundImage",  background.files[0]);
        }
          console.log(self.pageNew);
        formData.append("enabled", 0);
        formData.append("title", self.pageNew.title);
        formData.append("primaryColor", self.pageNew.primaryColor);
        formData.append("secondaryColor", self.pageNew.secondaryColor);
        formData.append("textColor", self.pageNew.textColor);
        formData.append("trackName", self.pageNew.trackName);
        formData.append("trackArtist", self.pageNew.trackArtist);
        formData.append("trackStems", self.pageNew.trackStems);
        formData.append("startDate", new Date(self.pageNew.startDate).getTime() / 1000);
        formData.append("endDate", new Date(self.pageNew.endDate).getTime() / 1000);
        formData.append("description", self.pageNew.description);
        formData.append("customUrl", self.pageNew.customUrl);
        formData.append("name", self.pageNew.name);
        
        axios.post("https://api.demobottle.com/contest", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        })       
        .then(function (response) {
          console.log(response);
          self.isLoading = false;
          self.$globals.getContests();
          self.activateFlow = false;
        })      
        .catch(function (error) {
          self.errors = error.response.data;
          self.isLoading = false;
        });
        
    }
  }
};
</script>